import {type UserNs} from '@shared/types/user.namespace';
import {FeatureNs} from "@shared/types/feature.namespace";

export namespace ScreenNs {

    export enum ScreenTypeEnums {
        GROUP = 'GROUP',
        IMAGE = 'IMAGE',

        // just for distinguising input fields from normal screens on editor tree!
        INPUT = 'INPUT',
        // just for distinguising project node from normal screen node on editor tree!
        PROJECT = 'PROJECT',
    }

    export enum ImageSizes {
        Medium = "screenM",
        Large = "screenL"
    }

    export interface ScreenBox {
        id: string;
        x: number,
        y: number,
        width: number,
        height: number;
        bgColor: string,
        orderNumber: number,
        featureId: string,
    }

    export interface ScreenImage {
        imageUrl: string,
        imageKey: string,
        imgVersion: number,
        createDate: Date,
        /** Whether this particular version came from Figma. Per version, not per screen. */
        fromFigma?: boolean,
    }

    export interface ScreenTreeNode extends Screen {
        hidden: boolean,
        children: Screen[],
        isReplaced: boolean
    }

    export interface Screen {
        id: string,
        parentId: string,
        summary: string,
        /** The screen's own Markdown description. */
        description?: string,
        screenType: ScreenTypeEnums,
        imageUrl: string,
        imageKey: string,
        orderNumber: number,
        properties?: any,
        boxes: ScreenBox[],
        featureList: string[],
        createdBy: UserNs.AuditUser,
        createDate: Date,
        updatedBy: UserNs.AuditUser,
        updateDate: Date,
        fromFigma: boolean,
        imgVersion: number,
        images: ScreenImage[]

        color: string,
        parentColor: string,
        hasChildren: boolean,
        checked: boolean,
        items: Screen[],
        folded: boolean,
        maxOrderNo: number,
        isIndex: boolean,
        hasNewVersion: boolean,
        figmaLastUpdateDate:Date,
        figmaFileKey: string,
        figmaNodeId: string,
    }

    /** Get All Screen Request */
    export interface GetAllScreenRequest {
        workspaceId: string;
        projectId: string;
        parentId: string;
    }

    /** Update Screen Parent Request */
    export interface UpdateScreenParentRequest {
        projectId: string;
        screenId?: string;
        parentId?: string;
        orders?: any[];
    }

    /** Update Screen Request */
    export interface UpdateScreenRequest {
        workspaceId: string;
        projectId: string;
        screen: any;
    }

    export interface ScreenFeatureRequest {
        workspaceId: string;
        projectId: string;
        screen: Screen;
    }

    export interface ScreenFeatures extends FeatureNs.Feature {
        id: string;
        box: ScreenBox;
    }

    /** Set Current Version Request */
    export interface SetCurrentVersionRequest {
        workspaceId: string;
        projectId: string;
        screenId: string;
        version: number;
    }

    /** Delete Version Request */
    export interface DeleteVersionRequest {
        workspaceId: string;
        projectId: string;
        screenId: string;
        version: number;
    }

    export interface UpdateScreenFromFigmaRequest {
        workspaceId: string,
        projectId: string,
        screenId: string
    }

    export interface GetFigmaProjectNameRequest {
        workspaceId: string,
        projectId: string,
        figmaFileKey: string
    }

    export interface FigmaProjectNameResponse {
        projectName: string
    }
}
